import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginContainerModel} from '../../../../../models/aggregates/id';
import { ApiResponseModel, ApiVisa } from '..';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TenantUserRegistrationService extends BaseApiTemplateService<AppLoginContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + '/identity/registration';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + '/identity/registration';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + '/identity/registration';
    this.httpClient = http;
  }

  /**
   * @param formData only .csv files are accepted.
   */
  public csvRegistration(formData: FormData, visa: ApiVisa): Observable<ApiResponseModel<string>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/group-registration';
    }
    return this.httpClient.post<ApiResponseModel<string>>(
      this.apiUrl,
      formData,
      this.getHttpHeader(visa)
    );
  }

}
